import Vue from 'vue'
import Vuex from 'vuex'

// import { createPersistedState, createSharedMutations } from 'vuex-electron'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    breadTwo: '',
    breadThree: '',
    currNavNum: 0,
  },
  mutations: {
    setBreadTwo: (state, currValue) => {
      state.breadTwo = currValue
    },
    setBreadThree: (state, currValue) => {
      state.breadThre = currValue
    },
    setCurrNavNum: (state, currValue) => {
      state.currNavNum = currValue
    },
  },
  actions: {},
  modules: {},
})
